import request from '@/utils/request';
const baseURL = '/api/posclient/';

//------------訂單相關-----------
//取得產品資訊
export function getSellProducts(data) {
  return request({
    method: 'post',
    url: `${baseURL}getSellProducts`,
    data,
  });
}

//建立訂單
export function createNewOrder(data) {
  return request({
    method: 'post',
    url: `${baseURL}createNewOrder`,
    data,
  });
}

//取得訂單詳細資料
export function orderInfo(data) {
  return request({
    method: 'post',
    url: `${baseURL}orderInfo`,
    data: {
      order_id: data,
    },
  });
}

//修改訂單
export function updateOrder(data) {
  return request({
    method: 'post',
    url: `${baseURL}updateOrder`,
    data,
  });
}

//放棄訂單
export function abrogateOrder(data) {
  return request({
    method: 'post',
    url: `${baseURL}abrogateOrder`,
    data,
  });
}

//取得未完成訂單編號
export function checkPendingOrder() {
  return request({
    method: 'post',
    url: `${baseURL}checkPendingOrder`,
  });
}

//整單折扣
export function addOrUpdateOrderDiscount(data) {
  return request({
    method: 'post',
    url: `${baseURL}addOrUpdateOrderDiscount`,
    data,
  });
}

//選擇一張電子券
export function useTicket(data) {
  return request({
    method: 'post',
    url: `${baseURL}useTicket`,
    data,
  });
}

//結帳
export function checkout(data) {
  return request({
    timeout: data.timeout || 25000,
    loading: data.timeout ? false : true,
    method: 'post',
    url: `${baseURL}checkout`,
    data,
  });
}

//測試結帳
export function testCheckout(data) {
  return request({
    timeout: data.timeout || 25000,
    loading: data.timeout ? false : true,
    method: 'post',
    url: `${baseURL}test/checkout`,
    data,
  });
}

//取消結帳
export function cancelCheckout(order_id) {
  return request({
    method: 'post',
    url: `${baseURL}cancelCheckout`,
    data: {
      order_id,
    },
  });
}

//結帳活動
export function registerCheckoutEvent(data) {
  return request({
    method: 'post',
    url: `${baseURL}registerCheckoutEvent`,
    data,
  });
}

//結帳活動：來店禮
export function redeemWelcomeGift(data) {
  return request({
    method: 'post',
    url: `${baseURL}redeemWelcomeGift`,
    data,
  });
}

//------------購物車相關------------
//加入or修改單一品項
export function addOrUpdateItem(data) {
  return request({
    method: 'post',
    url: `${baseURL}addOrUpdateItem`,
    data,
  });
}
//加入or修改特殊品項
export function updateSpecialItem(data) {
  return request({
    method: 'post',
    url: `${baseURL}updateSpecialItem`,
    data,
  });
}

//刪除單一品項
export function removeItem(data) {
  return request({
    method: 'post',
    url: `${baseURL}removeItem`,
    data,
  });
}

//刪除活動
export function removeEvent(data) {
  return request({
    method: 'post',
    url: `${baseURL}removeEvent`,
    data,
  });
}

//清空購物車
export function clearCart(data) {
  return request({
    method: 'post',
    url: `${baseURL}clearCart`,
    data,
  });
}

//更換品項
export function replaceItem(data) {
  return request({
    method: 'post',
    url: `${baseURL}replaceItem`,
    data,
  });
}

//客顯螢幕guest所需資料
export function pushInfo(data) {
  return request({
    loading: false,
    method: 'post',
    url: `${baseURL}ws/pushMessage`,
    data,
  });
}
